/**
 * The agent's own skills' SKILL.md, for their skill pages.
 *
 * The server only mirrors each agent skill's name and description
 * (`provider/amoreg/harnessSkills`); the method lives in
 * `apps/agents/amoreg/agent/skills/<name>/SKILL.md`, which the agent ships and
 * eve loads. The page reads those same files — bundled as lazy chunks, one per
 * skill — so what it shows is what the agent follows. A build without the
 * agent's sources finds none and the page says the method ships with the
 * agent.
 *
 * @module components/skills/agentSkillBodies
 */

const SKILL_FILES = import.meta.glob<string>("../../../../agents/amoreg/agent/skills/*/SKILL.md", {
  query: "?raw",
  import: "default",
});

/** The skill a SKILL.md path belongs to: its directory name. */
export const skillNameOfPath = (path: string): string | null =>
  /\/skills\/([^/]+)\/SKILL\.md$/.exec(path)?.[1] ?? null;

/** SKILL.md without its frontmatter: the method the page renders. */
export function skillMarkdownBody(source: string): string {
  const match = /^---\r?\n[\s\S]*?\r?\n---\r?\n?/.exec(source);
  return (match ? source.slice(match[0].length) : source).trim();
}

/** The method of an agent skill, or null when this build does not carry it. */
export async function loadAgentSkillBody(name: string): Promise<string | null> {
  const entry = Object.entries(SKILL_FILES).find(([path]) => skillNameOfPath(path) === name);
  if (!entry) return null;
  return skillMarkdownBody(await entry[1]());
}
